import React, { useCallback, useEffect, useRef, useState } from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { pieces } from '../data/woodworking';

function Carvings() {
  const [active, setActive] = useState(0);
  const touchStart = useRef<number | null>(null);
  const thumbs = useRef<(HTMLButtonElement | null)[]>([]);

  const step = useCallback((delta: number) => {
    setActive((i) => (i + delta + pieces.length) % pieces.length);
  }, []);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'ArrowRight') step(1);
      if (e.key === 'ArrowLeft') step(-1);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [step]);

  useEffect(() => {
    const thumb = thumbs.current[active];
    const strip = thumb?.parentElement;
    if (thumb && strip) {
      strip.scrollTo({ left: thumb.offsetLeft - (strip.clientWidth - thumb.clientWidth) / 2, behavior: 'smooth' });
    }
  }, [active]);

  const onTouchEnd = (e: React.TouchEvent) => {
    if (touchStart.current === null) return;
    const dx = e.changedTouches[0].clientX - touchStart.current;
    if (Math.abs(dx) > 40) step(dx < 0 ? 1 : -1);
    touchStart.current = null;
  };

  const piece = pieces[active];

  return (
    <div className="page">
      <h2 className="section-title">Some woodworking...</h2>

      <div className="slideshow">
        <div
          className="slideshow__stage"
          // A blurred copy of the photo fills the space around it
          style={{ '--backdrop': `url("${piece.src}")` } as React.CSSProperties}
          onTouchStart={(e) => {
            touchStart.current = e.touches[0].clientX;
          }}
          onTouchEnd={onTouchEnd}
        >
          <img key={piece.src} src={piece.src} alt={piece.title} className="slideshow__image" />
          <button className="slideshow__arrow slideshow__arrow--prev" aria-label="Previous" onClick={() => step(-1)}>
            <FiChevronLeft />
          </button>
          <button className="slideshow__arrow slideshow__arrow--next" aria-label="Next" onClick={() => step(1)}>
            <FiChevronRight />
          </button>
          <div className="slideshow__caption">
            <span className="slideshow__title">{piece.title}</span>
            <span className="slideshow__count">
              {active + 1} / {pieces.length}
            </span>
          </div>
        </div>

        <div className="slideshow__thumbs">
          {pieces.map((p, i) => (
            <button
              key={p.src}
              ref={(el) => {
                thumbs.current[i] = el;
              }}
              className={`slideshow__thumb ${i === active ? 'slideshow__thumb--active' : ''}`}
              aria-label={`Show ${p.title}`}
              aria-current={i === active}
              onClick={() => setActive(i)}
            >
              <img src={p.src} alt="" loading="lazy" />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Carvings;
